var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1zm16 3.08v11.84c0 1.676-1.94 2.609-3.25 1.561l-7.399-5.92a2 2 0 0 1 0-3.123l7.4-5.92C18.06 3.472 20 4.405 20 6.082zm-2 0L10.6 12l7.4 5.92z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }